"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _promise = require("hub-http/helpers/promise");

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _modelShim = _interopRequireDefault(require("../modelShim"));

var portalInfo;

var portalShim = function portalShim(portal) {
  return Object.assign((0, _modelShim.default)(portal), {
    isBasic: function isBasic() {
      return this.get('family_id') === 1;
    },
    isBasicOrHigher: function isBasicOrHigher() {
      return this.get('family_id') >= 1;
    },
    isProfessional: function isProfessional() {
      return this.get('family_id') === 2;
    },
    isProOrHigher: function isProOrHigher() {
      return this.get('family_id') >= 2;
    },
    isEnterprise: function isEnterprise() {
      return this.get('family_id') === 3;
    }
  });
};

var Portal = {
  get: function get() {
    return portalInfo;
  },
  then: function then() {
    var _Promise$resolve, _userInfo$then;

    if (portalInfo) return (_Promise$resolve = _promise.Promise.resolve(portalInfo)).then.apply(_Promise$resolve, arguments);
    return (_userInfo$then = (0, _userInfo.default)().then(function (_ref) {
      var portal = _ref.portal;
      portalInfo = portalShim(portal);
      return portalInfo;
    })).then.apply(_userInfo$then, arguments);
  }
};
var _default = Portal;
exports.default = _default;
module.exports = exports.default;